import React from 'react';
import { useWeb3 } from '@/hooks/useWeb3';

interface VestingScheduleItem {
  date: Date;
  amount: bigint;
  percentage: number;
  unlocked: boolean;
}

interface GrantScheduleProps {
  grantId: bigint;
  schedule: VestingScheduleItem[];
}

export const GrantSchedule: React.FC<GrantScheduleProps> = ({ grantId, schedule }) => {
  const web3 = useWeb3();

  return (
    <div>
      <h4 className="text-lg font-semibold text-gray-200 mb-4">Unlock Schedule</h4>
      <div className="space-y-3 max-h-96 overflow-y-auto pr-2 unlock-scroll">
        {schedule.length > 0 ? (
          schedule.map((item, index) => (
            <div
              key={index}
              className={`flex items-center justify-between p-4 rounded-xl transition-all duration-200 border ${
                item.unlocked
                  ? 'bg-green-500/10 border-green-500/30'
                  : 'glass-effect border-primary/10'
              }`}
            >
              <div className="flex items-center space-x-4">
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center shadow-lg ${
                    item.unlocked ? 'bg-primary shadow-primary/30' : 'bg-dark-lighter'
                  }`}
                >
                  {item.unlocked ? (
                    <svg
                      className="w-6 h-6 text-dark"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  ) : (
                    <svg
                      className="w-5 h-5 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      ></path>
                    </svg>
                  )}
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-200">
                    {item.date.toLocaleDateString()}
                    {index === 0 && (
                      <span className="ml-2 px-2 py-0.5 bg-primary/20 text-primary text-xs rounded-full border border-primary/30">
                        Cliff
                      </span>
                    )}
                  </p>
                  <p className="text-xs text-gray-500">{item.percentage.toFixed(3)}% of total</p>
                </div>
              </div>
              <div className="text-right">
                <p
                  className={`text-sm font-semibold ${
                    item.unlocked ? 'text-primary' : 'text-gray-400'
                  }`}
                >
                  {web3.formatTokenAmount(item.amount)}
                </p>
                <p className={`text-xs ${item.unlocked ? 'text-green-400' : 'text-gray-500'}`}>
                  {item.unlocked ? 'Unlocked' : 'Locked'}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-400 text-center py-8">
            Custom schedule - details not available in this view
          </p>
        )}
      </div>
    </div>
  );
};
